import bundled from "./site-config-fallback.json";

// Fallback default to bundled site-config.json if window.SITE_CONFIG is not defined
const siteConfig = window.SITE_CONFIG || bundled;

export default siteConfig;